import styles from './CartMobileSummary.module.scss'
import { CartModel } from '@/types/api'
import usePrice from '@/utils/hooks/usePrice'
import React from 'react'
import { useTranslation } from 'next-i18next'

type Props = {
  cart?: CartModel
}

const CartMobileSummary = (props: Props) => {
  const { t } = useTranslation('cart')
  const { price, formatPrice } = usePrice()

  return (
    <div className={styles.component}>
      <div className={styles.row}>
        <div>{t('shippingPrice')}</div>
        <div>{price(props.cart?.shippingPrice, true)}</div>
      </div>
      <div className={styles.row}>
        <div>{t('net')}</div>
        <div>{formatPrice(props.cart?.totalExludingVat, true)}</div>
      </div>
      <div className={styles.row}>
        <div>{t('vat')}</div>
        <div>{formatPrice(props.cart?.vatAmount, true)}</div>
      </div>
      <div className={styles.row}>
        <div>{t('total')}</div>
        <div>{formatPrice(props.cart?.totalAmount, true)}</div>
      </div>
    </div>
  )
}

export default CartMobileSummary